import { IResponseModel } from "../../IResponseModel";

export class LoginResponse implements IResponseModel {
    token: string;
    email_verified: boolean;
    username: string;
    email: string;
}